import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bank-accounts--set-default"
export default class extends Controller {
  connect() {
    // #set all hidden input fields for checkbox value non disabled
    const checkboxes = document.querySelectorAll('input[id^="bank_accounts_bank_accounts_attributes_"][id$="_default"]')
    if (checkboxes.length === 1) {
      checkboxes.forEach((checkbox) => {
        const hiddenField = checkbox.closest("div").querySelector('input[type="hidden"]')
        // Only update if the checkbox is disabled
        if (checkbox.disabled) {
          // Ensure the hidden field is enabled and hidden field send default value
          hiddenField.disabled = false
          // Match checkbox state
          hiddenField.value = checkbox.checked ? 1 : 0
        }
      })
    }
  }

  setDefault(event) {
    const selectedCheckbox = event.target // The clicked checkbox
    const checkboxes = document.querySelectorAll('input[id^="bank_accounts_bank_accounts_attributes_"][id$="_default"]')

    // Loop through all checkboxes
    checkboxes.forEach((checkbox) => {
      const hiddenField = checkbox.closest("div").querySelector('input[type="hidden"]')
      if (checkbox === selectedCheckbox) {
        checkbox.checked = true
        checkbox.value = 1
        checkbox.readonly = true
        hiddenField.value = 1
      } else {
        checkbox.checked = false
        checkbox.value = 0
        checkbox.readonly = false
        hiddenField.value = 0
      }
      hiddenField.disabled = false
    })
  }
}
